export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: true,
  selection: false,
  dialogClickModal: false,
  column: [
    {
      label: '内容',
      prop: 'text',
      type: 'textarea',
      span: 24,
      search: true,
      hide: false,
      display: true,
      overHidden: true,
      maxlength: 500,
      rules: [
        {
          required: true,
          message: '请输入内容',
          trigger: 'blur',
        },
        {
          max: 500,
          message: '内容最多不能超过500个字符',
          trigger: 'blur'
        }
      ],
    },
    {
      searchLabelWidth: 100,
      label: '是否已推送',
      prop: 'status',
      type: 'select',
      search: true,
      display: false,
      dicData: [
        {
          label: '否',
          value: '1'
        },
        {
          label: '是',
          value: '2'
        }
      ]
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'input',
      span: 12,
      search: false,
      display: false
    }
  ]
}